import styled from '@emotion/styled'
import { MediaQueries, theme } from '@hhgtech/hhg-components'
import { rem } from '@mantine/core'

import { SegmentedControl } from '../SegmentedControl'

export const StyledHomeTrendingSegmentedControl = styled(SegmentedControl)`
  .segmentedControlItem {
    min-width: 145px;
  }
`

export const StyledHomeTrendingHeader = styled.div`
  ${MediaQueries.smbDown} {
    & {
      overflow: overlay;
      padding-inline: ${rem(16)};
      padding-bottom: ${rem(8)};

      scrollbar-color: transparent transparent;
      &::-webkit-scrollbar {
        display: none;
      }
    }
  }
`

export const StyledHomeTrendingArticle = styled.div`
  &.homeTrendingSub {
    padding-block: ${rem(16)};
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      padding-bottom: 0;
    }

    + .homeTrendingSub {
      border-top: 1px solid ${theme.colors.neutral100};
    }
  }

  ${MediaQueries.tdDown} {
    &.homeTrendingMain {
      margin-bottom: ${rem(8)};
      .cardArticle {
        display: flex;
        flex-wrap: wrap;
        .cardArticleImageWrap {
          order: 3;
          width: 100%;
        }
        .cardArticleContent {
          order: 1;
          padding-top: 0;
        }
        .cardArticleFooter {
          order: 2;
          margin-bottom: ${rem(16)};
        }
      }
    }

    &.homeTrendingSub {
      &:first-child,
      &:last-child {
        padding-block: ${rem(16)};
      }
    }
  }

  ${MediaQueries.smbDown} {
    & {
      padding: ${rem(16)};
    }
  }
`

export const StyledHomeTrendingList = styled.div``
